import React from 'react';
import styled from 'styled-components';
import Table from '../../_Shared/Table';
import moment from 'moment';
import { WidgetContentItem } from '../../_Shared/Elements';
import { FaTrash as Trash } from '@react-icons/all-files/fa/FaTrash';
import Dropdown from '../../_Shared/DropdownWrapper';
import { IoEllipsisHorizontal } from '@react-icons/all-files/io5/IoEllipsisHorizontal';
import Api, { Actions, Endpoints } from '../../_Shared/Api';

const Reports = (props: any) => {
  const { results } = props.data.companies;
  const { UpdateSelf } = props.actions;
  const { getCompanies } = props;

  const handleClick = (data: any) => {
    UpdateSelf({ screen: 'company', company_id: data.id });
  };

  const deleteCompany = async (id: string, e: any) => {
    await Api(Endpoints['Hubspot'], Actions['RemoveCompany'], props.external_token, {}, [
      ['companyId', id],
    ]);
    getCompanies();
  };

  return (
    <>
      <SpaceWrapper>
        <Button className='button default' onClick={() => UpdateSelf({ screen: 'createCompany' })} ref={props.useRef}>
          Create Company
        </Button>
      </SpaceWrapper>
      <Table
        headers={[
          {
            label: 'Name',
            width: '20%',
            row: (row: any) => {
              const { name } = row.properties;
              return <Assignees>{name}</Assignees>;
            },
          },
          {
            label: 'Domain',
            width: '30%',
            row: (row: any) => {
              const { domain } = row.properties;
              return <Assignees>{domain}</Assignees>;
            },
          },
          {
            label: 'Industry',
            width: '30%',
            row: (row: any) => {
              const { industry } = row.properties;
              return <Assignees>{industry}</Assignees>;
            },
          },
          {
            label: 'Last Activity',
            width: '40%',
            row: (row: any) => {
              const { hs_lastmodifieddate } = row.properties;
              return <Assignees>{moment(hs_lastmodifieddate).format('LLL')}</Assignees>;
            },
          },
          {
            label: '',
            value: '',
            row: (row: any) => {
              const DropdownContent = (props: any) => {
                return (
                  <React.Fragment>
                    <WidgetContentItem
                      padding={10}
                      onClick={(e: any) => {
                        deleteCompany(row.id, e);
                        props.onClose();
                      }}
                    >
                      <Trash width={16} className='error' />
                      Remove Company
                    </WidgetContentItem>
                  </React.Fragment>
                );
              };
              return (
                <Dropdown items={DropdownContent}>
                  <IoEllipsisHorizontal width={16} style={{ fontSize: '16px' }} />
                </Dropdown>
              );
            },
            width: '5%',
          },
        ]}
        data={results || []}
        // expandingData={taskChild}
        parentKey='id'
        onClick={(row: any) => handleClick(row)}
        expandingRowClick={(row: any) => handleClick(row)}
      />
    </>
  );
};

export default Reports;

const SpaceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  left: 0;
`;


const Button = styled.div`
  text-align: center;
  cursor: pointer;
  font-weight: ${(props) => props.theme.textBold};
  margin: 0 2px;
  display: none;

  &.custom-padding {
    padding: 10px 15px !important;
    font-size: 12px;
    margin: 0 10px;
  }

  transition: box-shadow 0.3s ease-out;
  &:hover {
    box-shadow: ${(props) => props.theme.shadows.neumorphiclight};
  }
`;


const Assignees = styled.div`
  display: flex;
  flex-direction: row-reverse;

  & > div:not(:last-child) {
    margin-left: -10px;
  }

  & > div {
    transition: 0.3s transform ease-out;
    border: 1px solid white;
    &:hover {
      z-index: 2;
      border: 1px solid white;
      transform: scale(1.1);
    }
  }
`;
